//import { trackingApi } from '@sitecore-jss/sitecore-jss-tracking';
import { trackingApi } from '@sitecore-jss/sitecore-jss/tracking';
import axios from 'axios';
import config from 'temp/config';

/*const trackingApiOptions = {
  host: config.sitecoreApiHost,
  querystringParams: {
    sc_apikey: config.sitecoreApiKey,
  },
  fetcher: dataFetcher,
};*/

const trackingApiOptions = {
  host: config.sitecoreApiHost,
  querystringParams: {
    sc_apikey: config.sitecoreApiKey,
  },
};

export function dataFetcher(url, data) {
  return axios({
    url,
    method: data ? 'POST' : 'GET',
    data,
    withCredentials: true,
  });
}

export const track = (event) => {
  trackingApi
    .trackEvent([event], trackingApiOptions)
    .then((res) => {
      console.log('Tracking Event Response: ', res);
    })
    .catch((error) => console.error(error));
};
/*trackingApi
  .trackEvent(
    [
      { eventId: 'Download' }
    ], 
    trackingApiOptions
  )
  .then(() => console.log('Clicked Download button'))
  .catch((error) => console.error(error));*/
